import { type ReactElement, type SVGProps } from 'react';

export const SurfaceStorageIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m3.5 1.793 1.854 1.854-.708.707L4 3.707v13.086l.646-.646.708.707L3.5 18.708l-1.854-1.854.708-.707.646.646V3.707l-.646.647-.708-.707L3.5 1.793ZM22.208 20.5l-1.854 1.854-.707-.707.646-.647H7.207l.647.646-.707.708L5.293 20.5l1.854-1.854.707.708-.647.646h13.086l-.646-.646.707-.707 1.854 1.853ZM7 3v14h1v-3h12v3h1V3h-1v10h-2V5h-8v8H8V3H7Zm10 3v7h-6V6h2.5v3h1V6H17Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
